import { StateCreator } from 'zustand';
import type { Market, Ticker } from '@/types/api';

export interface MarketState {
  markets: Market[];
  tickers: Record<string, Ticker>;
  selectedSymbol: string | null;
  isLoading: boolean;
}

export interface MarketActions {
  setMarkets: (markets: Market[]) => void;
  updateTicker: (symbol: string, ticker: Ticker) => void;
  selectSymbol: (symbol: string | null) => void;
  setLoading: (isLoading: boolean) => void;
  clearMarkets: () => void;
}

export type MarketSlice = {
  market: MarketState & MarketActions;
};

const initialState: MarketState = {
  markets: [],
  tickers: {},
  selectedSymbol: null,
  isLoading: false,
};

export const createMarketSlice: StateCreator<MarketSlice> = (set) => ({
  market: {
    ...initialState,

    setMarkets: (markets) =>
      set((state) => ({
        market: { ...state.market, markets, isLoading: false },
      })),

    updateTicker: (symbol, ticker) =>
      set((state) => ({
        market: {
          ...state.market,
          tickers: { ...state.market.tickers, [symbol]: ticker },
        },
      })),

    selectSymbol: (symbol) =>
      set((state) => ({
        market: { ...state.market, selectedSymbol: symbol },
      })),

    setLoading: (isLoading) =>
      set((state) => ({
        market: { ...state.market, isLoading },
      })),

    clearMarkets: () =>
      set((state) => ({
        market: { ...state.market, ...initialState },
      })),
  },
});
